import React, { Component } from 'react';
import T from 'prop-types';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import Icon from '../../../components/Icon/Icon';
// styles
import styles from './ProgressChart.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class ProgressChart extends Component {
  constructor(props) {
    super(props);
    const { length } = props.data;
    const size = this.getSize(length);
    this.state = {
      size,
      left: length ? -size * length : 0,
      right: 0
    };
  }

  getSize = length => {
    if (length < 10) return 0;
    if (length < 20) return 10;
    return 50;
  };

  panLeft = () => {
    const { left, right, size } = this.state;
    if (left === 0) return;
    this.setState(() => ({
      right: right - size * 2,
      left: left + size * 2
    }));
  };

  panRight = () => {
    const { left, right, size } = this.state;
    if (right === 0) return;
    this.setState(() => ({
      left: left - size * 2,
      right: right + size * 2
    }));
  };

  render() {
    const { userColor, data } = this.props;
    const { left, right } = this.state;
    const hasNextButton = right < 0;
    const hasPrevButton = left < 0;

    return (
      <div className={cx('container')}>
        {hasPrevButton && (
          <button
            onClick={this.panLeft}
            className={cx('button', 'button-prev')}
          >
            <Icon type="arrow-chart" className={cx('icon')} />
          </button>
        )}

        <div className={cx('yaxis-wrapper')}>
          <LineChart width={70} height={245} data={data}>
            <YAxis domain={[0, 100]} />
          </LineChart>
        </div>

        <div className={cx('chart-wrapper')}>
          <ResponsiveContainer>
            <LineChart data={data}>
              <XAxis
                allowDataOverflow={true}
                dataKey="date"
                padding={{ left, right }}
              />
              <YAxis domain={[0, 100]} width={0} />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Legend align="center" />
              <Legend />
              <Line
                connectNulls={true}
                type="monotone"
                dataKey="sts"
                stroke={userColor}
                strokeWidth="2"
                activeDot={{ r: 6 }}
                name="Satisfaction"
              />
              <Line
                connectNulls={true}
                type="monotone"
                dataKey="rsk"
                stroke="#56CCF2"
                strokeWidth="2"
                activeDot={{ r: 6 }}
                name="Relapse Risk"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
        {hasNextButton && (
          <button
            onClick={this.panRight}
            className={cx('button', 'button-next')}
          >
            <Icon type="arrow-chart" className={cx('icon')} />
          </button>
        )}
      </div>
    );
  }
}

ProgressChart.propTypes = {
  userColor: T.string.isRequired
};

export default ProgressChart;



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/ProgressChart.js